<app-layout>
    <mat-toolbar class="page-header" role="heading">
      <h1>Reports</h1>
      <!-- <button mat-flat-button color="warn" routerLink="/ReportsList">Latest Reports</button> -->
      <div>
        <button mat-flat-button setColor="primaryColour" color="primary" *appHasFeature="features.REPORTS_ADMINISTRATOR" appPreventDoubleClick (throttledClick)="openNewReportDialog()" appLocalizationPopupDirective localizationCode="CreateCustomReport">
          <mat-icon aria-hidden="false" class="material-icons-outlined" aria-label="add icon">add</mat-icon>{{ 'CreateCustomReport' | translate: {Default: "Create Custom Report"} }}   
        </button>
      </div>
    </mat-toolbar>

    <div class="content">
        <ng-container *ngFor="let report of reports$ | async">
            <ng-container *appHasModuleAccess="report?.module">
                <mat-card 
                    setColor
                    [setColorRules]="[
                        {
                            color: 'primaryColour',
                            style: 'border-color'
                        }
                    ]"
                    [routerLink]="report.href" 
                    class="mat-elevation-z0 primaryHoverColor" 
                    *appHasFeature="report.featureCode"
                >
                    <div class="icon-div">
                        <span setColor="primaryColour" class="material-icons-outlined primaryColor">
                            {{report.icon}}
                        </span>
                    </div>
    
                    <div class="text">
                        <mat-card-title class="header">
                            {{report.name}}
                        </mat-card-title>
                        <mat-card-content>
                            {{report.detail}}
                        </mat-card-content>
                    </div>

                    <ng-container *appHasFeature="features.REPORTS_ADMINISTRATOR">
                        <div *ngIf="showMenu(report.id)" class="menu-actions">
                            <button
                                mat-icon-button
                                [matMenuTriggerFor]="reportMenu"
                                aria-label="Report actions"
                                (click)="$event.stopPropagation()"
                            >
                                <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                            </button>
    
                            <mat-menu #reportMenu="matMenu">
                                <button mat-menu-item (click)="$event.stopPropagation(); goToEditReport(report.id)">
                                    <mat-icon class="material-icons-outlined">edit</mat-icon>
                                    <span>{{ 'Edit' | translate: {Default: "Edit"} }}</span>
                                </button>
                            </mat-menu>
                        </div>

                    </ng-container>
                </mat-card>
            </ng-container>
        </ng-container>
    </div>

    <!-- <app-footer></app-footer> -->
</app-layout>
